var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"bg-color"},[_c('v-main',[_c('v-container',{attrs:{"fluid":"","grid-list-xs":"","pt-5":""}},[_c('div',{staticClass:"px-md-5"})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }